class NavModals {
  constructor() {
    this.$body = $('body');
    this.$navToggle = $('.js-menu-toggle');
    this.$navToggleText = $('.js-menu-toggle-text');
    this.$searchToggle = $('.js-search-toggle');
    this.$closeAll = $('.js-close-modals');
    this.$searchToggleText = $('.js-search-toggle-text');
    this.$siteSpineTag = $('.site-spine');

    this.navState = false;
    this.searchState = false;

    this.initialize();
  }

  initialize() {
    this.eventHandlers();
  }

  eventHandlers() {
    this.$navToggle.on('click', () => {
      this.navState ? this.closeNav() : this.openNav();
    });

    this.$searchToggle.on('click', () => {
      this.searchState ? this.closeSearch() : this.openSearch();
    });

    this.$closeAll.on('click', () => {
      this.closeNav();
      this.closeSearch();
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.navState === true || event.key === 'Escape' && this.searchState === true) {
        this.closeNav();
        this.closeSearch();
      }
    });

    document.addEventListener('scroll', () => {
      if (window.scrollY < 500) {
        this.hideLogo();
      } else {
        this.showLogo();
      }
    });
  }

  openNav() {
    this.closeSearch();
    this.$body.addClass('nav-open');
    this.$navToggleText.text('Close');
    this.navState = true;
  }

  closeNav() {
    this.$body.removeClass('nav-open');
    this.$navToggleText.text('Menu');
    this.navState = false;
  }

  openSearch() {
    this.closeNav();
    this.$body.addClass('search-open');
    this.$searchToggleText.text('Close');
    this.searchState = true;
    $('#site-search').focus();
  }

  closeSearch() {
    this.$body.removeClass('search-open');
    this.$searchToggleText.text('Search');
    this.searchState = false;
  }

  showLogo() {
    this.$siteSpineTag.addClass('show-logo');
  }

  hideLogo() {
    this.$siteSpineTag.removeClass('show-logo');
  }
}

export default NavModals;
